(() => {
	angular
		.module('main')
		.controller('InvoiceViewController', InvoiceViewController);

	InvoiceViewController.$inject = [
		'$scope',
		'$rootScope',
		'$routeParams',
		'$location',
		'$http',
		'jobDataService',
		'messageService',
		'fileUploadService',
		'validationService',
		'emailService',
		'invoicesDataService'
	];

	function InvoiceViewController(
		$scope,
		$rootScope,
		$routeParams,
		$location,
		$http,
		jobDataService,
		messageService,
		fileUploadService,
		validationService,
		emailService,
		invoicesDataService
	) {
		$scope.data = {};

		$scope.$on('$viewContentLoaded', () => {
			$scope.invoiceId = $routeParams.id;
		});

		$scope.sendMessage = {};
		$scope.sendMessage.addInvoiceAttachment = true;
		$scope.attachmentsData = {
			attachments: [],
			filesSize: 0
		};

		let clientsEmailTimer;
		$scope.clientEmails = [];

		function emailSearchRequest(search) {
			jobDataService
				.searchClient(search)
				.then(result => findClientSuccessCallback(result.data))
				.catch(messageService.showDefaultErrorMessage);
		}

		function findClientSuccessCallback(client) {
			if (client) {
				$scope.clientEmails.length = 0;
				client.forEach(item => $scope.clientEmails.push(item));
			}
		}

		$scope.setEmail = function(site) {
			let stringEmail = angular.copy(site.name);
			stringEmail = stringEmail.substring(
				stringEmail.indexOf('(') + 1,
				stringEmail.length - 1
			);

			$scope.sendMessage.emailCc = stringEmail;
			$scope.emailCcObj = Object.assign({ email: stringEmail }, site);
		};

		$scope.$watchCollection('sendMessage', newValue => {
			if (newValue) {
				if (!newValue.emailCc) {
					$scope.sendMessage.emailCc =
						angular.element('#sendInvoiceMessageData_emailCc').val() || '';
				}

				if (
					$scope.sendMessage &&
					$scope.sendMessage.emailCc &&
					$scope.sendMessage.emailCc.length > 0
				) {
					if (clientsEmailTimer != null) {
						clearTimeout(clientsEmailTimer);
					}

					clientsEmailTimer = setTimeout(
						emailSearchRequest($scope.sendMessage.emailCc),
						500
					);
				} else {
					clearTimeout(clientsEmailTimer);
				}
			}
		});

		$scope.toggleViewCc = function(state) {
			if ($scope.sendMessage && $scope.sendMessage.emailCc) {
				$scope.sendMessage.emailCc = '';
			}

			if ($scope.sendMessage && !$scope.sendMessage.addInvoiceAttachment) {
				$scope.sendMessage.addInvoiceAttachment = true;
			}

			$scope.showCcField = state !== undefined ? state : !$scope.showCcField;

			if (state === false) {
				$scope.attachmentsData = {
					attachments: [],
					filesSize: 0
				};
			}
		};

		$scope.addContactMail = function(contactEmail) {
			$scope.contactEmail = contactEmail;
		};

		// Email methods
		$scope.retrySendMail = function() {
			getInvoiceInformation($routeParams.id);
			emailService.callLastEmailFn();
		};

		$scope.showSendInvoice = function(isReceipt, receiptId) {
			$scope.isSendReceiptSpinnningWheelActive = true;
			$rootScope.backId = $scope.data.id;
			$scope.receiptId = receiptId;
			delete $scope.sendMessage;
			$scope.sendMessage = {};
			$scope.sendMessage.addInvoiceAttachment = true;
			$scope.sendReceipt = !!isReceipt;

			$http.get('/protected/rest/email_templates/get').then(
				result => {
					if (result.data) {
						$scope.$evalAsync();

						$scope.emails = result.data;

						if ($scope.emails) {
							const template = isReceipt
								? 'RECEIPT_OF_PAYMENT_EMAIL_TEMPLATE'
								: 'INVOICE_EMAIL_TEMPLATE';
							$scope.choosenEmail =
								$scope.emails.find(
									item => item.emailTemplateType === template
								) || {};
						}
						$('#sendInvoiceModal')
							.modal('show')
							.on('shown.bs.modal', () => {
								const input = $('#sendInvoiceModal').find('input');

								validationService.isModalClosePrevented(input);
							});
					}
					$scope.isSendReceiptSpinnningWheelActive = false;
				},
				() => {
					$scope.isSendReceiptSpinnningWheelActive = false;
				}
			);
		};

		$scope.$watch('choosenEmail', newValue => {
			if (typeof newValue !== 'undefined' && newValue != null) {
				$http
					.get(
						`/protected/rest/settings/email_template/get/${
							newValue.id
						}?forSend=true`
					)
					.then(result => successGetEmailTemplate(result.data));
			}
		});

		function successGetEmailTemplate(email) {
			if (email) {
				$scope.sendMessage.emailSubject = email.subject;
				$scope.sendMessage.emailText = email.text.replace(
					/class="linkEdited"/g,
					'class=""'
				);
				if (email.storedAttachments && email.storedAttachments.length) {
					$scope.attachmentsData = {
						attachments: fileUploadService.convertAttachmentsToShow(
							email.storedAttachments
						)
					};
				} else {
					clearAttachments();
				}

				const rootEmail = $rootScope.primaryContact
					? $rootScope.primaryContact.email || ''
					: '';
				$scope.sendMessage.emailTo = $scope.contactEmail || rootEmail;

				$scope.sendMessage.emailCc = '';
			}
		}

		$scope.sendInvoice = function() {
			$scope.isSendInvoiceSpinnningWheelActive = true;

			const maxSize = 10; // 10Mb

			if (
				$scope.attachmentsData &&
				$scope.attachmentsData.filesSize > maxSize
			) {
				messageService.showToaster('w_0', 'attachments');
				$scope.isSendInvoiceSpinnningWheelActive = false;
				return false;
			}

			let url;

			if (typeof $rootScope.backId === 'undefined') {
				$rootScope.backId = $routeParams.id;
			}

			const sendInvoiceFromInvoiceViewUrl = `/protected/rest/invoices/invoice/send/${
				$rootScope.backId
			}`;
			const sendInvoiceFromJobViewUrl = `/protected/rest/invoices/invoice/send/${
				$routeParams.id
			}`;
			const sendReceiptUrl = `/protected/rest/payment-receipt/${
				$scope.receiptId
			}/send`;

			$scope.$evalAsync();

			if ($location.path().includes('invoices')) {
				url = $scope.sendReceipt
					? sendReceiptUrl
					: sendInvoiceFromInvoiceViewUrl;
			} else {
				url = sendInvoiceFromJobViewUrl;
			}

			$scope.disableBtnOnSend = true;
			$scope.sendMessage.templateId = $scope.choosenEmail
				? $scope.choosenEmail.id
				: '';
			$scope.sendMessage.emailText = $rootScope.addMaiStyling(
				$scope.sendMessage.emailText
			);
			const obj2save = angular.copy($scope.sendMessage);

			$scope.sendMessage.emailCc = $scope.showCcField ? obj2save.emailCc : '';
			const formData = new FormData();
			angular.forEach($scope.sendMessage, (value, key) => {
				formData.append(key, value);
			});
			const storedFiles = $scope.attachmentsData.attachments.filter(
				file => file.id
			);
			const uploadedFiles = $scope.attachmentsData.attachments.filter(
				file => !file.id
			);

			angular.forEach(uploadedFiles, (value, key) => {
				formData.append(`attachments[${key}]`, value);
			});

			angular.forEach(storedFiles, (value, key) => {
				formData.append(`storedAttachments[${key}]`, value.id);
			});
			$http({
				method: 'POST',
				url,
				data: formData,
				transformRequest: angular.identity,
				headers: {
					'Content-Type': undefined
				}
			})
				.then(
					result => successSendInvoice(result.data),
					error => errorSendInvoice(error)
				)
				.finally(() => {
					$scope.isSendInvoiceSpinnningWheelActive = false;
				});
		};

		function successSendInvoice() {
			$('#sendInvoiceModal').modal('hide');
			$scope.disableBtnOnSend = false;
			$scope.showCcField = false;

			$scope.$evalAsync();

			clearAttachments();
			$scope.isJobView = $location.path().includes('/jobs/view/');
			$scope.isLeadView = $location.path().includes('/leads/view/');
			if ($scope.isJobView) {
				invoicesDataService.emitInvoiceUpdateEvent('UPDATE_SN_INVOICES');
				$rootScope.updateJobView();
			} else if ($scope.isLeadView) {
				$rootScope.updateLeadView();
				invoicesDataService.emitInvoiceUpdateEvent('UPDATE_SN_INVOICES');
			}

			const messageCode = $scope.sendReceipt ? 's_11' : 's_9';

			messageService.showToaster(messageCode, 'payments');

			const path = $location.path();

			if (path.includes('payments') || path.includes('invoices')) {
				snCommunicationAdapter.callMethod('getInvoice');
			}
		}

		function errorSendInvoice({ status, data }) {
			$scope.disableBtnOnSend = false;

			const errorMessage = data.errorMessage;
			let errorCode, errorPlace, value;

			if (status >= 400 && status < 500 && errorMessage) {
				if (status == 423) {
					const limit = $rootScope.isUserTrial ? 50 : 150;
					return messageService.showToaster('e_4', 'generalValidation', limit);
				} else if (
					errorMessage === 'Email text should contain an invoice link'
				) {
					const path = $location.path();
					const isNotInvoiceTemplate =
						path.includes('jobs') ||
						path.includes('payments') ||
						path.includes('invoices');

					errorPlace = isNotInvoiceTemplate ? 'editInvoice' : 'emailTemplate';

					if ($scope.sendReceipt) {
						errorCode = 'e_7';
					} else if (!$scope.sendReceipt && isNotInvoiceTemplate) {
						errorCode = 'e_3';
					} else {
						errorCode = 'e_0';
					}
				} else if (errorMessage.includes('Email address inactive')) {
					errorCode = 'e_1';
					errorPlace = 'generalValidation';
					value = $scope.sendMessage.emailTo;
				} else {
					errorCode = 'e_2';
					errorPlace = 'general';
					value = errorMessage;
				}
			} else {
				errorCode = 'e_0';
				errorPlace = 'general';
			}
			messageService.showToaster(errorCode, errorPlace, value);
		}

		function clearAttachments() {
			if ($scope.attachmentsData && $scope.attachmentsData.attachments) {
				if ($scope.attachmentsData.attachments.length) {
					$scope.attachmentsData.attachments.length = 0;
				}
			}
		}

		$scope.disableDragDrop = () => true;

		$(document).on('show.bs.modal', '#sendInvoiceModal', () => {
			$scope.$broadcast('addedFileEvent');
		});
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/invoiceViewController.js